<template>
  <div>
    <el-dialog
      title="生成合同"
      :visible.sync="dialog"
      :width="getIsMobile?'100%':'70%'"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleClose"
      :append-to-body="true"
      class="dialog"
    >
      <el-table :data="data" border>
        <el-table-column label="序号" prop="">
          <template #default="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="型号" prop="xhname"/>
        <el-table-column label="品牌" prop="source"/>
        <el-table-column label="数量" prop="num">
          <template #default="{ row,$index }">
            <el-input v-model.number="row.num" type="text" placeholder="请输入数量"/>
          </template>
        </el-table-column>
        <el-table-column label="单价" prop="price">
          <template #default="{ row }">
            <el-input v-model="row.price" type="text" placeholder="请输入单价"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="总价" prop="zprice"/>
        <el-table-column label="备注" prop="bz">
          <template #default="{ row }">
            <el-input v-model="row.bz" type="text" placeholder="请输入备注"></el-input>
          </template>
        </el-table-column>
      </el-table>
      <el-form :model="form" ref="formRef" style="margin-top: 20px">
        <el-form-item label="是否含税" prop="shui">
          <el-radio-group v-model="form.shui">
            <el-radio :label="0">含税</el-radio>
            <el-radio :label="2">未税</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <el-button type="primary" style="margin-top: 8px" @click="openCompany">选择联系人</el-button>
      <el-card v-if="showInfo" style="margin-top: 10px">
        <Contact :allInfo="allInfo" ref="contactRef" :editInfo="editInfo"/>
      </el-card>
      <el-divider>开票资料</el-divider>
      <InvoiceInfo ref="invoiceInfoRef" :id="companyId" @getInfo="getInfo"/>
      <el-button type="primary" style="margin-top: 8px" @click="quotationContract">生成合同</el-button>
    </el-dialog>
    <el-dialog
      title="选择公司联系人"
      :visible.sync="showCompany"
      :width="getIsMobile?'100%':'70%'"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleClose"
      :append-to-body="false"
    >
      <CompanyContact @quotationContact="getContact"  :contractId="companyId"/>
    </el-dialog>
  </div>
</template>
<script>
import { defineComponent, getCurrentInstance, reactive, ref, watch,toRaw,nextTick } from '@vue/composition-api'
import useRootSetting from '@/hooks/useRootSetting'
import InvoiceInfo from './invoiceInfo.vue'
import CompanyContact from '@/components/Contacts/contacts.vue'
import request from "@/utils/request"
import Contact from './contact.vue'
import {Message} from "element-ui";
export default defineComponent({
  name: 'CreateQuotation',
  components: { Contact, CompanyContact, InvoiceInfo },
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: () => []
    },
    companyId: {
      type: [String,Number],
      default: ''
    }
  },
  setup(props, { emit }) {
    const { getIsMobile } = useRootSetting()
    const instance = getCurrentInstance()
    const router = instance.proxy.$router
    const username = instance.proxy.$store.getters.name
    const showCompany = ref(false) //显示报价公司
    const showInfo = ref(false) //显示公司的信息
    const contactRef = ref(null)
    const infoRef = ref(null)
    const formRef = ref(null)
    const invoiceInfoRef = ref(null)
    const form  = reactive({
      shui: 0
    })
    //关闭报价公司弹窗
    const handleClose = () => {
      showCompany.value = false
      emit('close')
    }

    //打开报价公司弹窗
    const openCompany = () => {
      showCompany.value = true
    }

    //选择联系人给所有字段赋值
    const allInfo = reactive({
      name: '',
      bumen: '',
      lxrtel: '',
      lxrphone: '',
      lxrmax: '',
      email: ''
    })
    const getContact = (row) => {
      showInfo.value = true
      const {name,phone,bumen,max,email,tel,cid} = row
      allInfo.name = name
      allInfo.bumen = bumen
      allInfo.lxrphone = phone
      allInfo.email = email
      allInfo.lxrtel = tel
      allInfo.lxrmax = max
      showCompany.value = false
    }

    //生成合同
    const quotationContract = () => {
      // console.log(invoiceInfoRef.value.form)
      // const invoiceFormData = invoiceInfoRef.value.form;
        request({
          url:'ci_create_contract_update.yy',
          method:'post',
          data: {
            id:props.companyId,
            username: username,
            kpzt: form.shui,
            ...invoiceInfoRef.value.form,
            ...contactRef.value.form,
            childdata: props.data
          }
        }).then(res => {
          if (res.code == 200) {
              Message.success(res.msg)
             router.push({name: 'customerInformation'});
          }
        })
    }

    watch(() => props.data, (val) => {
      val.forEach(item => {
        item.zprice = Number((item.price * item.num).toFixed(2))
      })
    },{deep: true,immediate: true})

    const editInfo = ref([])
    const getInfo = (val) => {
      showInfo.value = true
      editInfo.value = val
    }


    return {
      editInfo,
      invoiceInfoRef,
      form,
      formRef,
      infoRef,
      username,
      allInfo,
      showInfo,
      showCompany,
      getIsMobile,
      contactRef,
      getInfo,
      getContact,
      handleClose,
      openCompany,
      quotationContract
    }
  }
})
</script>
<style scoped lang="scss">
.input-error {
  border: 1px solid red;
}
.error-text {
  color: red;
  font-size: 12px;
  margin-left: 5px;
}
</style>
